import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Tooltip } from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/dukService";

import DataTableBloc from "../Blocs/DataTableBloc";
import apiResponse from "../../../../../services/apiResponse";

import ReactTimeAgo from "react-time-ago";
import moment from "moment";

class TableActiveComponent extends Component {
  dataTableBloc = new DataTableBloc();

  source;
  historyTable = "historyDUKTableActive";
  defaultOrder = "rank_order";
  defaultSize = 10;
  defaultSort = "asc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      inactiveUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: false,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  dateParse = (input) => {
    let res = "-";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    let additionalFilter = this.props.additionalFilter;

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      ...additionalFilter,
    };
    await this.dataTableBloc.fetchRowTable(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.inactiveData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  inactiveData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };

  componentDidMount() {
    // this.setTokenAPI()

    this.dataTableBloc.rowtableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel.unsubscribe();
  }

  columns = [
    {
      key: "employee_nip",
      text: "NIP - Nama",
      className: "employee_nip",
      sortable: false,
      width: "80",
      cell: (record) => {
        return (
          <>
            <b>{record.employee_nip}</b>
            <div>{record.employee_full_name}</div>
          </>
        );
      },
    },
    {
      key: "employee_current_work_unit_name",
      text: "Unit Kerja",
      className: "employee_current_work_unit_name",
      sortable: false,
      // width: '20%'
    },
    {
      key: "golongan",
      text: "Pangkat",
      className: "text-center",
      sortable: false,
    },
    {
      key: "tmt_pangkat",
      text: "TMT Pangkat",
      className: "text-center",
      sortable: false,
      cell: (record) => {
        return this.dateParse(record.tmt_pangkat);
      },
    },
    {
      key: "jabatan_new",
      text: "Jabatan",
      className: "",
      sortable: false,
    },
    {
      key: "tmt_jabatan",
      text: "TMT Jabatan",
      className: "text-center",
      sortable: false,
      cell: (record) => {
        return this.dateParse(record.tmt_jabatan);
      },
    },
    {
      key: "echelon_name",
      text: "Eselon",
      className: "echelon_name",
      sortable: false,
    },
    {
      key: "masa_kerja_golongan",
      text: "MKG",
      className: "masa_kerja_golongan",
      sortable: false,
    },
    {
      key: "masa_kerja_keseluruhan",
      text: "MKS",
      className: "masa_kerja_keseluruhan",
      sortable: false,
    },
    {
      key: "nama_diklat",
      text: "Nama Diklat",
      className: "",
      sortable: false,
    },
    {
      key: "tahun_diklat",
      text: "Tahun Diklat",
      className: "",
      sortable: false,
    },
    {
      key: "pendidikat_terakhir",
      text: "Pendidikan",
      className: "",
      sortable: false,
    },
    {
      key: "tahun_lulus",
      text: "Tahun Lulus",
      className: "",
      sortable: false,
    },
    {
      key: "employee_age",
      text: "Usia",
      className: "text-center",
      sortable: false,
    },
    {
      key: "employee_categories_name",
      text: "Status",
      className: "text-center",
      sortable: false,
    },
    // {
    //     key: "employee_create_date",
    //     text: "Tanggal",
    //     className: "rating",
    //     sortable: false,
    //     cell: record => {
    //         return moment(record.employee_create_date).format('DD/MM/YYYY');
    //     }
    // },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 120,
      sortable: false,
      align: "center",
      cell: (record) => {
        const thisId = record.employee_id;
        return (
          <Fragment>
            <span>
              <button
                className="btn btn-primary btn-sm"
                id={"detail-" + thisId}
                onClick={() => {
                  this.setState({
                    detailUuid: record.employee_uuid,
                  });

                  // set current employee uuid selected
                  let dataUser = {
                    employee_uuid: record.employee_uuid,
                    employee_name: record.employee_name,
                    employee_full_name: record.employee_full_name,
                    employee_current_position_name:
                      record.employee_current_position_name,
                    employee_nip: record.employee_nip,
                  };
                  localStorage.setItem(
                    "employeeSelected",
                    JSON.stringify(dataUser)
                  );
                }}
                style={{
                  marginRight: "2px",
                  padding: "2px 5px",
                }}
              >
                <i className="uil-file-search-alt"></i>
              </button>
              <Tooltip
                style={{
                  marginBottom: 2,
                }}
                placement="top"
                isOpen={this.state["detail" + thisId]}
                target={"detail-" + thisId}
                toggle={() => {
                  this.setState({
                    ["detail" + thisId]: !this.state["detail" + thisId],
                  });
                }}
              >
                Lihat Data Pegawai
              </Tooltip>
            </span>
          </Fragment>
        );
      },
    },
  ];

  render() {
    return (
      <>
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menghapus data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil dihapus"
          failedTitle="Gagal!"
          failedInfo="Data gagal dihapus"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.detailUuid !== null ? (
          // <Redirect to={"/sample.html?detail&uuid=" + this.state.detailUuid}/>
          <Redirect to={"/kepegawaian/home.html?identitas"} />
        ) : null}
        {/* { this.state.updateUuid !== null ?
                    <Redirect to={"/kepegawaian/home.html?update&uuid=" + this.state.updateUuid}/>
                : null } */}
      </>
    );
  }
}

export default TableActiveComponent;
